/** Copyright (C) 2023 Trend Micro Inc. All rights reserved. */

// @ts-nocheck

const IS_TESTING = process.env.NODE_ENV === 'test'
export const RUNTIME_ENV_VITE_SERVICE_ROUTE_BASE = IS_TESTING
  ? 'mock-route-base'
  : import.meta.env?.VITE_SERVICE_ROUTE_BASE
export const RUNTIME_ENV_VITE_IS_DEV = IS_TESTING || import.meta?.env?.DEV
